import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase/firebase";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    if (!email) {
      setError("Bitte gib deine E-Mail-Adresse ein.");
      setLoading(false);
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Ein Link zum Zurücksetzen des Passworts wurde an deine E-Mail gesendet.");
    } catch (err) {
      setError("Fehler: Überprüfe deine E-Mail-Adresse.");
    }
    setLoading(false);
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="modal-content rounded-4 shadow" style={{ width: "400px" }}>
        <div className="modal-header p-5 pb-4 border-bottom-0">
          <h1 className="fw-bold mb-0 fs-2">Passwort zurücksetzen</h1>
        </div>

        <div className="modal-body p-5 pt-0">
          <form onSubmit={handleResetPassword}>
            <div className="form-floating mb-3">
              <input 
                type="email" 
                className="form-control rounded-3"
                id="floatingEmail" 
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label htmlFor="floatingEmail">Email address</label>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}

            <button className="w-100 btn btn-lg rounded-3 btn-primary" type="submit" disabled={loading}>
              {loading ? "Senden..." : "Passwort zurücksetzen"}
            </button>

            <div className="text-center mt-3">
              <a href="/login" className="text-decoration-none">Zurück zum Login</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
